<template>
    <div class="text-right">
        <form class="form-inline code-block">
            <div class="form-group">
                <label for="PromotionalCode">Promotional Code:</label>
                <input type="text" class="form-control" id="PromotionalCode" placeholder="Enter Code" v-model="promoCode">
                <button type="submit" class="btn btn-sm btn-outline-danger" v-on:click.stop.prevent="apply()">Apply</button>
            </div>

            <div class="form-group wrap text-danger text-left" v-if="errorMessage.length > 0">
                <span>{{ errorMessage }}</span>
            </div>
        </form>
    </div>
</template>

<script type="text/jsx">
    import { mapState } from 'vuex'
    export default {
        name: 'promotional-code-form',
        data: function () {
            return this.getDefaultData();
        },
        computed: {
            ...mapState([
                'promo'
            ]),
            appliedPromoCode: {
                get: function () {
                    return this.$store.state.promo.promo_code || '';
                }
            }
        },
        created: function () {
            this.promoCode = this.appliedPromoCode;
        },
        methods: {
            getDefaultData: function () {
                return {
                    promoCode: '',
                    errorMessage: ''
                };
            },
            notify: function (promo) {
                this.$store.commit('applyPromoCode', promo);
                Object.assign(this.$data, {
                    promoCode: this.appliedPromoCode,
                    errorMessage: ''
                });
            },
            reset: function (msg) {
                Object.assign(this.$data, {
                    promoCode: '',
                    errorMessage: '' // msg || 'Promotional code was not found.'
                });
                this.$store.commit('applyPromoCode', {});
            },
            apply: function () {
                /* global FRS_CAMPAIGN, FRS_API_HOST */
                var endpoint = window.location.protocol + FRS_API_HOST + '/api/promocode/validate';
                var payload = {
                    'campaign': FRS_CAMPAIGN,
                    'code': this.promoCode
                };
                this.$http.post(endpoint, payload).then(function (response) {
                    var body = response.body || {};
                    if ('error' in body) {
                        this.reset(body.error);
                    } else {
                        let promo = body.promo || {};
                        this.notify(promo);
                    }
                }, function(error) {
                    this.reset();
                });
                return false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// promotional-code-form.vue?e5ef84fa